import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4076ba0f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("审批通过")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("审批不通过")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("审核不通过记录")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("代员工确认工资")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("发送企微工资确认")
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("未确认")
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("未确认")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("不通过")

import { ref } from 'vue'
import salaryMonth from '@/views/ViewsComponents/salary/salaryTemplate.vue'
import store from '@/store/index'
import { formatNumber } from '@/utils/index'
import { ElMessage, ElMessageBox } from 'element-plus/lib/components';
import dayjs from 'dayjs'
import Api from '@/http/modules/index'
import { isMobile } from '@/global_mixin/tableMixin';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  'POST/salaries/distributes/monthly_salary': fetchList,
  // 员工列表(不分页,下拉框)
  'GET/users/list': userListApi,
  // 获取所有团队
  'GET/organizations': organizationsApi,
  // 工资条审批
  'POST/approvals/salary_approval': salary_approvalApi,
  // 审核不通过记录
  'GET/approvals/failed_records': failed_recordsApi,
  // 帮员工工资手动确认
  'POST/approvals/manual_confirm': manual_confirmApi,
  // 再次通知企微确认工资
  'POST/salaries/again_notice': again_noticeApi,
} = Api

let selectRows = ref<any[]>([])
const salaryElement = ref()
const monthSearchConfig = ref([
  {
    type: "TIME",
    label: "月份",
    value: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
    upKey: 'month',
    props: {
      type: 'month',
      clearable: true,
      'default-value': null,
    }
  },
  {
    type: 'SELECT',
    label: '团队',
    value: '',
    upKey: 'orgId',
    options: [],
    placeholder: '请选择团队',
    selectFunc: organizationsApi,
    seleProps: { label: 'name', valueName: 'id', },
    props: { placeholder: '请选择团队', clearable: true }
  },
  {
    type: "SELECT",
    label: "员工确认",
    value: "",
    upKey: "confirm",
    options: [
      { name: '已确认', id: true },
      { name: '未确认', id: false },
    ],
    placeholder: "请选择员工确认",
    props: { clearable: true },
    seleProps: {
      label: "name",
      valueName: "id",
    },
  },
  {
    type: "SELECT",
    label: "领导审批",
    value: "",
    upKey: "leaderConfirm",
    options: [
      { name: '已确认', id: true },
      { name: '未确认', id: false },
    ],
    placeholder: "请选择领导审批",
    props: { clearable: true },
    seleProps: {
      label: "name",
      valueName: "id",
    },
  },
  {
    type: "SELECT",
    label: "员工状态",
    value: null,
    upKey: "staffType",
    options: [
      { name: 'ALL', id: null },
      { name: '在职', id: true },
      { name: '离职', id: false },
    ],
    placeholder: "请选择领导审批",
    props: { clearable: true },
    seleProps: {
      label: "name",
      valueName: "id",
    },
  },
  {
    type: 'SELECT',
    label: '员工',
    value: [],
    upKey: 'userIds',
    options:  store.getters.sysUsers,
    props: { placeholder: '请选择员工', multiple: true, 'collapse-tags': true, style: 'width: 250px', clearable: true },
    seleProps: {
      label: 'label',
      valueName: 'userId',
    }
  },
  {
    type: 'SELECT',
    selectType: 'GROUP',
    label: '公司',
    value: '',
    upKey: 'companyId',
    options: store.getters.sysCompany,
    props: { placeholder: '请选择公司', clearable: true },
    seleProps: { label: 'name', valueName: 'id', },
  },
])

// 通过与不通过
const passFg = ref<boolean>(false)
const passReason = ref<string>('')

const passHandle = (fg: boolean) => {
  if(selectRows.value.length === 0){
    ElMessage.warning('请至少选择一个用户')
    return
  }
  if(fg){
    // 通过
    ElMessageBox.confirm(
      '是否确认通过',
      'Warning',
      {  
        confirmButtonText: '确定',
        cancelButtonText: '取消 ',
        type: 'warning',
      }
    )
      .then(() => {
        salaryElement.value.MI_identify = true
        return salary_approvalApi({
          batchIds: selectRows.value.map(_user => _user.batchId),
          userIds: selectRows.value.map(_user => _user.userId),
          leaderConfirm: true,
          message: '',
        })
      })
      .then(() => {
        salaryElement.value.MI_identify = false
        // searchHandle(MI_params)
        salaryElement.value.searchHandle(salaryElement.value.MI_params)
        ElMessage.success('成功')
      })
      .catch(() => {
        salaryElement.value.MI_identify = false
      })
    return
  }
  // 不通过
  passFg.value = true
  passReason.value = ''
}

const failHandle = () => {
  if(!passReason.value) {
    ElMessage.warning('请填写审核不通过原因')
    return
  }
  salaryElement.value.MI_identify = true

  salary_approvalApi({
    batchIds: selectRows.value.map(_user => _user.batchId),
    userIds: selectRows.value.map(_user => _user.userId),
    leaderConfirm: false,
    message: passReason.value,
  }).then(() => {
    salaryElement.value.MI_identify = false

    passFg.value = false
    passReason.value = ''
    ElMessage.success('成功')
    // searchHandle(MI_params)
    salaryElement.value.searchHandle(salaryElement.value.MI_params)
  }).catch(() => {
    salaryElement.value.MI_identify = false
  })
}

// 审核不通过记录按钮
const failFg = ref(false)
let failList = ref<any>([])
const showFailedList = async () => {
  salaryElement.value.MI_identify = true
  try {
    failList.value = await failed_recordsApi()
    salaryElement.value.MI_identify = false
    failFg.value = true
  } catch (error) {
    salaryElement.value.MI_identify = false
  }
}


// 员工工资手动确认
const confirmSalary = () => {
  if(selectRows.value.length === 0){
    ElMessage.warning('请至少选择一条数据')
    return
  }
  ElMessageBox.confirm(
    '是否手动确认工资?',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
      salaryElement.value.MI_identify = true;
      return manual_confirmApi({
        confirmList: selectRows.value.map(_user => {
          return {
            batchId: _user.batchId,
            userId: _user.userId
          }
        })
      })
    })
    .then(() => {
      salaryElement.value.MI_identify = false
      ElMessage.success('成功')
      // searchHandle(MI_params)
      salaryElement.value.searchHandle(salaryElement.value.MI_params)
    })
    .catch(() => {
      salaryElement.value.MI_identify = false
    })
}


// 搜索七级以上员工
const sevenLevel = ref<boolean>(false)
const levelChange = (_sevenLevel: boolean) => {
  salaryElement.value.searchHandle({...salaryElement.value.MI_params, sevenLevel})
}

const tableRowClassName = ({row}: any) => {
  if(row.staffType === false){
    return 'bull-row'
  }
}

// 发送企微确认通知
const sendWeChat = () => {
  if(selectRows.value.length === 0){
    ElMessage.warning('请至少选择一条数据')
    return
  }
  ElMessageBox.confirm('是否发送企微通知?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
    .then(() => {
      salaryElement.value.MI_identify = true;
      return again_noticeApi({
        ids: selectRows.value.map(_user => _user.userId)
      })
    }).then(() => {
      salaryElement.value.MI_identify = false
      ElMessage.success('成功')
      salaryElement.value.searchHandle(salaryElement.value.MI_params)
    }).finally(() => {
      salaryElement.value.MI_identify = false
    })
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(salaryMonth, {
      ref_key: "salaryElement",
      ref: salaryElement,
      onSelectionRows: _cache[6] || (_cache[6] = (rows) => _isRef(selectRows) //@ts-ignore
 ? selectRows.value = rows : selectRows = rows),
      "basic-params": {},
      "basic-api": _unref(fetchList),
      "basic-search-config": monthSearchConfig.value,
      "row-class-name": tableRowClassName
    }, {
      buttonArea: _withCtx(() => [
        _createVNode(_component_el_space, {
          wrap: "",
          class: "mt-5"
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (passHandle(true))),
              type: "success",
              plain: ""
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            })), [
              [_directive_permission, 'Write']
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (passHandle(false))),
              type: "danger",
              plain: ""
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })), [
              [_directive_permission, 'Write']
            ]),
            _createVNode(_component_el_button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (showFailedList()))
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (confirmSalary())),
              type: "primary"
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })), [
              [_directive_permission, 'Write']
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (sendWeChat()))
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })), [
              [_directive_permission, 'Write']
            ]),
            _createVNode(_component_el_checkbox, {
              class: "ml-10",
              onChange: levelChange,
              modelValue: sevenLevel.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((sevenLevel).value = $event)),
              label: "搜索七级以上员工",
              size: "large"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      columnHead: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "55",
          selectable: (row) => (row.userId + '') !== _ctx.$store.getters.userId
        }, null, 8, ["selectable"]),
        _createVNode(_component_el_table_column, {
          label: "姓名",
          prop: "userName",
          width: "130",
          fixed: "",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(`${row.userName}(${row.alias})`), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "员工确认",
          prop: "confirm",
          width: "85"
        }, {
          default: _withCtx(({ row }) => [
            (row.confirm)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, "已确认"))
              : (_openBlock(), _createBlock(_component_el_tag, {
                  key: 1,
                  type: "danger",
                  effect: "plain"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "领导确认",
          prop: "leaderConfirm",
          width: "85"
        }, {
          default: _withCtx(({ row }) => [
            (row.leaderConfirm)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, "已确认"))
              : (_openBlock(), _createBlock(_component_el_tag, {
                  key: 1,
                  type: "danger",
                  effect: "plain"
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        })
      ]),
      columnEnd: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "单位社保合计",
          prop: "companySocialSecurity",
          align: "right",
          formatter: _unref(formatNumber),
          width: "110"
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "最终成本",
          prop: "finalCost",
          align: "right",
          formatter: _unref(formatNumber),
          width: "110"
        }, null, 8, ["formatter"])
      ]),
      _: 1
    }, 8, ["basic-api", "basic-search-config"]),
    _createVNode(_component_el_dialog, {
      title: "审批不通过",
      width: _unref(isMobile) ? '90%' : '',
      modelValue: passFg.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((passFg).value = $event))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[8] || (_cache[8] = ($event: any) => (passFg.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          onClick: _cache[9] || (_cache[9] = ($event: any) => (failHandle())),
          type: "danger",
          plain: ""
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: passReason.value,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((passReason).value = $event)),
          rows: 7,
          type: "textarea",
          placeholder: "请输入不通过原因"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["width", "modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "审批不通过列表",
      width: _unref(isMobile) ? '90%' : '',
      modelValue: failFg.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((failFg).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: _unref(failList),
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "姓名",
              prop: "username",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "审核状态",
              prop: "leaderConfirm"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.leaderConfirm === false ? '不通过' : '通过'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "审核人",
              prop: "leaderName"
            }),
            _createVNode(_component_el_table_column, {
              label: "原因",
              prop: "remarks",
              "show-overflow-tooltip": ""
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["width", "modelValue"])
  ]))
}
}

})